module.exports = __webpack_public_path__ + "img/测点_抱闸.b9df252d.png";